import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

enum operazioniInterventi {
  RENDI_IDONEO = 'Rendi idoneo',
  SEGNALAZIONE_NON_IDONEA = 'Segnalazione non idonea',
  PROPONI_A_FINANZIAMENTO = 'Proponi a finanziamento',
  AUTORIZZA = 'Autorizza',
  RESPINGI = 'Respingi',
  ESPUNGI = 'Espungi',
  RIMODULA = 'Rimodula'
}

@Injectable({
  providedIn: 'root'
})
export class InterventiService {
  constructor(private http: HttpClient,private datePipe: DatePipe) { }

  getList(page, size, sort: string, filters?: ModelEventiCalamitosi.InterventoSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        if(key == "dataInizioLavoriDa" || key == "dataInizioLavoriA" || key == "dataFineLavoriDa" || key == "dataFineLavoriA"){
          filters[key] = this.datePipe.transform(filters[key], "yyyy/MM/dd");
        }
        searchParams = searchParams.append(key, filters[key]);
      }
    }
    return this.http
      .get<ModelEventiCalamitosi.InterventoDtoElenco[]>(`${environment.urls.base}/interventi/list`,
        {
          params: searchParams
        });
  }

  getListaPriorita() {
    return this.http
    .get<ModelEventiCalamitosi.PrioritaDto[]>(`${environment.urls.base}/interventi/lista-priorita`);
  }

  getListaTpRimodulazioni() {
    return this.http
    .get<ModelEventiCalamitosi.TipologiaRimodulazioneDto[]>(`${environment.urls.base}/interventi/lista-tipologia-rimodulazione`);
  }

  getOperazioni(): ModelEventiCalamitosi.OperazioniInterventi[] {
    let ops: ModelEventiCalamitosi.OperazioniInterventi[] = [];
    ops.push({idOperazione:1, descOperazione:operazioniInterventi.RENDI_IDONEO})
    ops.push({idOperazione:2, descOperazione: operazioniInterventi.SEGNALAZIONE_NON_IDONEA})
    ops.push({idOperazione:3, descOperazione: operazioniInterventi.PROPONI_A_FINANZIAMENTO})
    ops.push({idOperazione:4, descOperazione: operazioniInterventi.AUTORIZZA})
    ops.push({idOperazione:5, descOperazione: operazioniInterventi.RESPINGI})
    ops.push({idOperazione:6, descOperazione: operazioniInterventi.ESPUNGI})
    ops.push({idOperazione:7, descOperazione: operazioniInterventi.RIMODULA})
    return ops;
  }



  save(ocdpc: string,
    controlList: ModelEventiCalamitosi.InterventoDtoElenco[],
    operazioneSuTutti: string,
    operazioneDaEffettuare: number,
    interventiSearchableDto: ModelEventiCalamitosi.InterventoSearchableDto,
    motivazione?:string,
    importoRimodulazione?:number
   ) {
      let listaInterventiDTO: ModelEventiCalamitosi.ListaInterventiDTO = {
        controlList: controlList,
        ocdpc: ocdpc,
        operazioneSuTutti: operazioneSuTutti,
        operazione: operazioneDaEffettuare,
        filtro: interventiSearchableDto,
        motivazioneOperazione:motivazione
      }
      if(importoRimodulazione !== null) listaInterventiDTO.importoRimodulazione = importoRimodulazione;

    return this.http
    .post<number>(
      `${environment.urls.base}/interventi/cambia-stato-interventi`,
      listaInterventiDTO,
      {
        observe: 'response'
      }
    );
  }

  public getIntervento(idIntervento: number) {
    return this.http
      .get<ModelEventiCalamitosi.AnaInterventiDgpeDTO>(`${environment.urls.base}/interventi/id/${idIntervento}`);
  }

  public upsertIntervento(interventoEdit: ModelEventiCalamitosi.AnaInterventiDgpeDTO) {
    return this.http
      .post<ModelEventiCalamitosi.CampoModuloDTO>(
        `${environment.urls.base}/interventi/upsert`,
        interventoEdit,
        {
          observe: 'response'
        }
      );
  }
}
